import { put, call } from 'redux-saga/effects';
import { crewUnapprovedCount,crewList,crewAllList, crewEdit,crewBasicInfoAdd,crewBasicInfoUpdate,crewAvailability,crewApprove,crewDelete,crewSkillList, crewSkillSave,chiefEligibility, crewCsvImport, crewScheduleShiftStatus, crewScheduleShiftCheckIn, crewScheduleShiftCheckOut, crewRemovalFromShift,crewInduction, crewTimesheetList, crewFeedbackList, crewNotesList, crewNotesAdd, crewNotesDocumentAdd, crewNotesDocumentDelete } from '../services/crewService';
import { aflt_skillList } from '../services/settings/affiliates/aflt_skillService';

import * as types from '../actions';


export function* crewListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewList, payload);
    yield put({ type: types.CREW_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewListDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewList, payload);
    yield put({ type: types.CREW_LIST_DOWNLOAD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_LIST_DOWNLOAD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewAllListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewAllList, payload);
    yield put({ type: types.CREW_ALL_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_ALL_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewBasicInfoAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(crewBasicInfoAdd, payload);
      yield put({ type: types.CREW_BASIC_INFO_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.CREW_BASIC_INFO_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewBasicInfoUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewBasicInfoUpdate, payload);
    yield put({ type: types.CREW_BASIC_INFO_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_BASIC_INFO_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewEdit, payload);
    yield put({ type: types.CREW_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewAvailabilitySaga(payload) {
  try {
    const response = yield call(crewAvailability, payload);
    yield put({ type: types.CREW_AVAILABILITY_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_AVAILABILITY_ERROR, error });
  }
}

export function* crewApproveSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewApprove, payload);
    yield put({ type: types.CREW_APPROVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_APPROVE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewChiefEligibilitySaga(payload) {
  try {
    const response = yield call(chiefEligibility, payload);
    yield put({ type: types.CREW_CHIEF_APPROVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_CHIEF_APPROVE_ERROR, error });
  }
}


export function* crewDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewDelete, payload);
    yield put({ type: types.CREW_ACTIVE_DEACTIVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_ACTIVE_DEACTIVE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewSkillListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewSkillList, payload);
    yield put({ type: types.CREW_SKILL_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_SKILL_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewSkillSaveSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewSkillSave, payload);
    yield put({ type: types.CREW_SKILL_SAVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_SKILL_SAVE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewAffSkillListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_skillList, payload);
    yield put({ type: types.CREW_AFFILIATE_SKILL_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_AFFILIATE_SKILL_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }

}

export function* crewCsvImportSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewCsvImport, payload);
    yield put({ type: types.CREW_IMPORT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CREW_IMPORT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewScheduleShiftStatusSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewScheduleShiftStatus, payload);
    yield put({ type: types.CREW_SCHEDULE_SHIFT_STATUS_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_SCHEDULE_SHIFT_STATUS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewScheduleShiftCheckInSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewScheduleShiftCheckIn, payload);
    yield put({ type: types.CREW_SCHEDULE_SHIFT_CHECKIN_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_SCHEDULE_SHIFT_CHECKIN_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewScheduleShiftCheckOutSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewScheduleShiftCheckOut, payload);
    yield put({ type: types.CREW_SCHEDULE_SHIFT_CHECKOUT_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* crewRemovalFromShiftSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewRemovalFromShift, payload);
    yield put({ type: types.CREW_REMOVAL_FROM_SHIFT_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_REMOVAL_FROM_SHIFT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewInductionSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewInduction, payload);
    yield put({ type: types.CREW_INDUCTION_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_INDUCTION_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewTimesheetListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewTimesheetList, payload);
    yield put({ type: types.CREW_TIMESHEET_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_TIMESHEET_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewFeedbackListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewFeedbackList, payload);
    yield put({ type: types.CREW_FEEDBACK_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_FEEDBACK_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* crewUnapprovedCountSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewUnapprovedCount, payload);
    yield put({ type: types.CREW_UNAPPROVED_COUNT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CREW_UNAPPROVED_COUNT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewNotesListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewNotesList, payload);
    yield put({ type: types.CREW_NOTES_LIST_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_NOTES_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewNotesAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewNotesAdd, payload);
    yield put({ type: types.CREW_NOTES_ADD_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_NOTES_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* crewNotesDocumentAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewNotesDocumentAdd, payload);
    yield put({ type: types.CREW_NOTES_DOCUMENT_ADD_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.CREW_NOTES_DOCUMENT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* crewNotesDocumentDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(crewNotesDocumentDelete, payload);
    yield put({ type: types.CREW_NOTES_DOCUMENT_DELETE_SUCCESS, response})
  } catch(error) {
    yield put({ type: types.CREW_NOTES_DOCUMENT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

